module.exports = __webpack_public_path__ + "img/vector.8f890ece.png";